export default __webpack_public_path__ + "static/media/facebook.7616ef08.svg";